// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3XmdB","additionalInfo":"AgreementModal_additionalInfo__1-fbZ"};